import { createAction, createStandardAction } from 'typesafe-actions'
import { FetchProjectsPayload, SelectedType } from '@chegg-wt/core/state/projects/types'
import { UpdateProjectVariables } from '@chegg-wt/core/queries/UpdateProject'
import { ActionTypes } from '@chegg-wt/core/state/projects/constants'
import { Order, OrderBy } from '@chegg-wt/core/globalTypes'
import { DeleteProjectsVariables } from '@chegg-wt/core/queries/DeleteProjects'
import { createErrorAction } from '@chegg-wt/core/utils/actions'
import { ProjectTypeKey } from '@chegg-wt/core/constants/projectTypeKey'

export const storeProjects = createAction(
  ActionTypes.FETCH_PROJECTS_SUCCEEDED,
  (action) => {
    return (projects) => action({ projects })
  }
)

export const fetchProjects = createAction(ActionTypes.FETCH_PROJECTS, (action) => {
  return (params: FetchProjectsPayload = {}) => action(params)
})

export const setProjectFilter = createAction(ActionTypes.SET_PROJECT_FILTER, (action) => {
  return (filter: ProjectTypeKey) => action({ filter })
})

export const searchProjects = createAction(ActionTypes.SEARCH_PROJECTS, (action) => {
  return (searchValue: string) => action({ searchValue })
})

export const fetchProjectsError = createErrorAction(ActionTypes.FETCH_PROJECTS_ERROR)

export const sortProjects = createAction(ActionTypes.SORT_PROJECTS, (action) => {
  return (sort: OrderBy, order: Order) => action({ orderBy: sort, order })
})

export const sortProjectsError = createErrorAction(ActionTypes.SORT_PROJECTS_ERROR)

export const starProject = createAction(ActionTypes.STAR_PROJECT, (action) => {
  return (id: string) => action({ id })
})

export const unStarProject = createAction(ActionTypes.UNSTAR_PROJECT, (action) => {
  return (id: string) => action({ id })
})

export const starProjectError = createErrorAction(ActionTypes.STAR_PROJECT_ERROR)

export const unStarProjectError = createErrorAction(ActionTypes.UNSTAR_PROJECT_ERROR)

export const batchDeleteProjects = createStandardAction(
  ActionTypes.BATCH_DELETE_PROJECTS
)<DeleteProjectsVariables>()

export const editCiteProject = createStandardAction(
  ActionTypes.EDIT_PROJECT
)<UpdateProjectVariables>()

export const editCiteProjectError = createErrorAction(ActionTypes.EDIT_PROJECT_ERROR)

export const setProjectsOrder = createAction(ActionTypes.SET_ORDER, (action) => {
  return (order: Order) => action({ order })
})

export const setProjectsSortName = createAction(ActionTypes.SET_SORT_NAME, (action) => {
  return (sortName: SelectedType) => action({ sortName })
})
